// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1v9Bt","field":"styles_field__45ORq","fieldCol":"styles_fieldCol__12u2M","diffCol":"styles_diffCol__1CI_4","diff":"styles_diff__20Q8R"};